/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineResponse20027
 */
export interface InlineResponse20027 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20027
     */
    dpayRecipient: string;
}

export function InlineResponse20027FromJSON(json: any): InlineResponse20027 {
    return InlineResponse20027FromJSONTyped(json, false);
}

export function InlineResponse20027FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20027 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dpayRecipient': json['dpayRecipient'],
    };
}

export function InlineResponse20027ToJSON(value?: InlineResponse20027 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dpayRecipient': value.dpayRecipient,
    };
}


